export const BILL_FORM_BASE_MODULE_ID = 'bill-form-base-module-id'
